import { ACTIVE_AUDIO_NODE_STORE } from '../globals';
import { TIsActiveAudioNodeFunction } from '../types';

export const isActiveAudioNode: TIsActiveAudioNodeFunction = (audioNode) => ACTIVE_AUDIO_NODE_STORE.has(audioNode);
